import { Box, Flex, Text } from '@radix-ui/themes'
import cn from 'classnames'
import {
  COMPATIBILITY_STATUS_OPTIONS,
  compatibilityStatusBarBgClass,
  compatibilityStatusLabel,
  type CompatibilityStatus
} from '../constants'

interface CompatibilityProgressBarProps {
  byCompatibility: Record<CompatibilityStatus, number>
  total: number
  showLegend?: boolean
}

export const CompatibilityProgressBar = ({
  byCompatibility,
  total,
  showLegend = true
}: CompatibilityProgressBarProps) => {
  if (total === 0) return null

  const segments = COMPATIBILITY_STATUS_OPTIONS.map((status) => ({
    status,
    count: byCompatibility[status],
    percent: Math.round((byCompatibility[status] / total) * 100)
  })).filter((segment) => segment.count > 0)

  return (
    <Flex direction="column" gap="2">
      <Flex className="h-2 w-full rounded-full overflow-hidden bg-[var(--gray-a3)]">
        {segments.map((segment) => (
          <Box
            key={segment.status}
            className={cn('h-full', compatibilityStatusBarBgClass[segment.status])}
            style={{ width: `${(segment.count / total) * 100}%` }}
            title={`${compatibilityStatusLabel[segment.status]}: ${segment.count}`}
          />
        ))}
      </Flex>

      {showLegend && (
        <Flex gap="4" wrap="wrap">
          {segments.map((segment) => (
            <Flex key={segment.status} align="center" gap="2">
              <Box
                className={cn('h-2.5 w-2.5 rounded-full shrink-0', compatibilityStatusBarBgClass[segment.status])}
              />
              <Text size="1">
                {compatibilityStatusLabel[segment.status]}{' '}
                <Text color="gray">
                  {segment.count} ({segment.percent}%)
                </Text>
              </Text>
            </Flex>
          ))}
        </Flex>
      )}
    </Flex>
  )
}
